import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext.jsx";

export default function CartWidget() {
  const { totalItems } = useCart();
  const navigate = useNavigate();

  const buttonLabel = useMemo(() => (
    totalItems > 0 ? `Cart, ${totalItems} item${totalItems === 1 ? "" : "s"}` : "Cart"
  ), [totalItems]);

  return (
    <div className="cart-widget">
      <button
        type="button"
        className={`social-btn cart-widget__button${totalItems > 0 ? " cart-widget__button--has-items" : ""}`}
        data-header-interaction="cart"
        aria-label={buttonLabel}
        onClick={() => navigate("/featured/cart")}
      >
        <span className="cart-widget__icon-wrap">
          <svg
            className="cart-widget__icon-svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M4 4h2l1.6 9.2a2 2 0 0 0 2 1.7h7.5a2 2 0 0 0 1.9-1.4L20 8H7.2"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="11" cy="19" r="1.4" fill="currentColor" />
            <circle cx="17" cy="19" r="1.4" fill="currentColor" />
          </svg>
          {totalItems > 0 && (
            <span className="cart-widget__count-badge">
              {totalItems}
            </span>
          )}
        </span>
        <span className="cart-widget__label">CART</span>
      </button>
    </div>
  );
}
